import React from 'react';
import moment from 'moment';
import {
    makeStyles, withStyles, Typography, Button, Divider,
    createTheme, responsiveFontSizes, MuiThemeProvider,
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import Comment from './Comment'
import customAxios from "../../../components/API/customAxios";
import { useIntl } from 'react-intl';
import Timeline from './Timeline'
import Title from '../../LeaveApplication/component/Balance/Title';
import { breakpoints } from '../../UIComponent/CommonStyle'

let statusColor = '';

let firstProcessingStatusColor = '';
let secProcessingStatusColor = '';
let finalProcessingStatusColor = '';

let showFirstPending = true;
let showFirstApproved = false;
let showFirstRejected = false;
let showFirstNA = false;

let showSecPending = true;
let showSecApproved = false;
let showSecRejected = false;
let showSecNA = false;

let showFinalPending = true;
let showFinalApproved = false;
let showFinalRejected = false;
let showFinalNA = false;
let showFinalSeparator = true;

let firstApproveText = ''
let secApproveText = ''
let finalApproveText = ''
let showFirstApprover = false;
let showSecApprover = false;

const dateTimeFormat = 'YYYY/MM/DD, HH:mm';

let muiTheme = createTheme({
    overrides: {
        MuiTimeline: {
            root: {
                padding: '0px 0px',
                [breakpoints.up("sm")]: {
                    padding: '6px 16px',
                },
            }
        }
    }
});
muiTheme = responsiveFontSizes(muiTheme);
const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: '5px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1, 1, 1),
        [breakpoints.up("sm")]: {
            padding: theme.spacing(2, 4, 3),
        },
        width: 550
    },
    title: {
        fontSize: 14,
        fontWeight: 600,
    },
    subtitle: {
        marginBottom: 12,
    },
    comment: {
        marginBottom: theme.spacing(1),
    },
    typeDiv: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    typeMarker: {
        fontSize: 15,
    },
    statusDiv: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    statusButton: {
        color: '#FFF',
        borderRadius: 10,
        height: 22,
        marginLeft: theme.spacing(1),
    },
    approveStatusIcon: {
        color: '#369E64',
        fontSize: 25
    },
    pendingIcon: {
        color: '#808080',
        fontSize: 25
    },
    timelineContentContainer: {
        textAlign: 'left'
    },
    timelineContent: {
        display: 'inline-block',
        textAlign: 'center',
        width: 120,
        minWidth: 50
    },
    approverName: {
        backgroundColor: '#384B63',
        color: '#FFF',
        borderRadius: '5px 5px 0 0',
        fontSize: 12
    },
    processingContent: {
        fontSize: 12
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

const StyledDivider = withStyles({
    root: {
        background: '#DCDCDC',
        height: 2,
        marginTop: 6,
        marginBottom: 6,
    },
})(Divider);

export default function Details({ handleClose, open, showId, page, isNewCompLeave }) {
    const classes = useStyles();
    const intl = useIntl();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [showModel, setShowModel] = React.useState(false);
    const [showTimeline, setShowTimeline] = React.useState(false);
    const [updatedTime, setUpdatedTime] = React.useState();
    const [showWithdrawnTime, setShowWithdrawnTime] = React.useState(false);
    const [showCancelledTime, setShowCancelledTime] = React.useState(false);
    const [myLeave, setMyLeave] = React.useState({
        employeeName: '',
        type: '',
        startDate: '',
        startTime: '',
        untilDate: '',
        endTime: '',
        status: '',
        firstApprover: '',
        firstApproverComment: '',
        secApprover: '',
        secApproverComment: '',
        HRComment: '',
    });

    const pendingStatus = intl.formatMessage({ id: 'status.1' });
    const approvededOn = intl.formatMessage({ id: 'myleave.approved_on' });
    const rejectedOn = intl.formatMessage({ id: 'myleave.rejected_on' });

    React.useEffect(() => {
        let url = ''
        const isCompLeave = page.includes('Comp Leave');
        if (isCompLeave) {
            url = '/get_my_comp_leave_reqs/';
        } else {
            url = '/get_my_leave/';
        }

        customAxios.get(url + showId)
            .then(res => {
                let getMyLeave = res.data[0];
                let getFirstApprover = res.data[1];
                let getSecApprover = res.data[2];
                let getFirstProcessing = res.data[3];
                let getSecProcessing = res.data[4];
                let getFinalProcessing = res.data[5];
                let firstApproveTime = moment(getFirstProcessing.updated_at).format(dateTimeFormat);
                setUpdatedTime(moment(getMyLeave.updated_at).format(dateTimeFormat));

                if (String(getMyLeave.status) === window.global.withdrawn) {
                    setShowTimeline(false);
                    setShowWithdrawnTime(true);
                } else {
                    setShowTimeline(true);
                    setShowWithdrawnTime(false);
                }

                if (String(getMyLeave.status) === window.global.cancelled) {
                    setShowCancelledTime(true);
                } else {
                    setShowCancelledTime(false);
                }

                if (getMyLeave.until_date === null) {
                    getMyLeave.until_date = ''
                }

                if (getMyLeave.end_time === null) {
                    getMyLeave.end_time = ''
                }

                // First Approver Handling
                if (getFirstApprover) {
                    showFirstApprover = true;
                    switch (String(getFirstProcessing.status)) {
                        case window.global.pending:
                        case window.global.submitted:
                            firstProcessingStatusColor = '#808080'
                            showFirstPending = true;
                            showFirstApproved = false;
                            showFirstRejected = false;
                            showFirstNA = false;
                            firstApproveText = pendingStatus;
                            break;
                        case window.global.approved:
                            firstProcessingStatusColor = 'green'
                            showFirstPending = false;
                            showFirstApproved = true;
                            showFirstRejected = false;
                            showFirstNA = false;
                            firstApproveText = approvededOn + ' ' + firstApproveTime
                            break;
                        case window.global.rejected:
                            firstProcessingStatusColor = 'red'
                            showFirstPending = false;
                            showFirstApproved = false;
                            showFirstRejected = true;
                            showFirstNA = false;
                            firstApproveText = rejectedOn + ' ' + firstApproveTime
                            break;
                        case window.global.cancelled:
                            firstProcessingStatusColor = '#808080'
                            showFirstPending = false;
                            showFirstApproved = false;
                            showFirstRejected = false;
                            showFirstNA = true;
                            firstApproveText = 'NA'
                    }
                } else {
                    showFirstApprover = false;
                }

                // Second Approver Handling
                if (getSecApprover) {
                    showSecApprover = true;
                    showFinalSeparator = true;
                    if (getSecProcessing) {
                        let secondApproveTime = moment(getSecProcessing.updated_at).format(dateTimeFormat);
                        switch (String(getSecProcessing.status)) {
                            case window.global.pending:
                            case window.global.submitted:
                                secProcessingStatusColor = '#808080'
                                showSecPending = true;
                                showSecApproved = false;
                                showSecRejected = false;
                                showSecNA = false;
                                secApproveText = pendingStatus;
                                break;
                            case window.global.approved:
                                secProcessingStatusColor = 'green'
                                showSecPending = false;
                                showSecApproved = true;
                                showSecRejected = false;
                                showSecNA = false;
                                secApproveText = approvededOn + ' ' + secondApproveTime
                                break;
                            case window.global.rejected:
                                secProcessingStatusColor = 'red'
                                showSecPending = false;
                                showSecApproved = false;
                                showSecRejected = true;
                                showSecNA = false;
                                secApproveText = rejectedOn + ' ' + secondApproveTime
                                break;
                            case window.global.withdrawn:
                            case window.global.cancelled:
                                secProcessingStatusColor = '#808080'
                                showSecPending = false;
                                showSecApproved = false;
                                showSecRejected = false;
                                showSecNA = true;
                                secApproveText = 'NA'
                        }
                    } else {
                        secProcessingStatusColor = '#808080'
                        showSecPending = true;
                        showSecApproved = false;
                        showSecRejected = false;
                        showSecNA = false;
                        secApproveText = pendingStatus;
                    }
                } else {
                    showSecApprover = false;
                }


                // HR Endorse Handling
                if (getFinalProcessing) {
                    let HRProcessingApproveTime = moment(getFinalProcessing.updated_at).format(dateTimeFormat);
                    switch (String(getFinalProcessing.status)) {
                        case window.global.pending:
                        case window.global.submitted:
                            finalProcessingStatusColor = '#808080'
                            showFinalPending = true;
                            showFinalApproved = false;
                            showFinalRejected = false;
                            showFinalNA = false;
                            finalApproveText = pendingStatus;
                            break;
                        case window.global.approved:
                            finalProcessingStatusColor = 'green'
                            showFinalPending = false;
                            showFinalApproved = true;
                            showFinalRejected = false;
                            showFinalNA = false;
                            finalApproveText = intl.formatMessage({ id: 'myleave.endorsed_on' }) + ' ' + HRProcessingApproveTime
                            break;
                        case window.global.rejected:
                            finalProcessingStatusColor = 'red'
                            showFinalPending = false;
                            showFinalApproved = false;
                            showFinalRejected = true;
                            showFinalNA = false;
                            finalApproveText = rejectedOn + ' ' + HRProcessingApproveTime
                            break;
                        case window.global.withdrawn:
                        case window.global.cancelled:
                            finalProcessingStatusColor = '#808080'
                            showFinalPending = false;
                            showFinalApproved = false;
                            showFinalRejected = false;
                            showFinalNA = true;
                            finalApproveText = 'NA'
                    }
                } else if (getSecProcessing) {
                    switch (String(getSecProcessing.status)) {
                        case window.global.pending:
                        case window.global.submitted:
                            finalProcessingStatusColor = '#808080'
                            showFinalPending = true;
                            showFinalApproved = false;
                            showFinalRejected = false;
                            showFinalNA = false;
                            finalApproveText = pendingStatus;
                            break;
                        case window.global.approved:
                            finalProcessingStatusColor = '#808080'
                            showFinalPending = true;
                            showFinalApproved = false;
                            showFinalRejected = false;
                            showFinalNA = false;
                            finalApproveText = pendingStatus;
                            break;
                        case window.global.rejected:
                            finalProcessingStatusColor = '#808080'
                            showFinalPending = false;
                            showFinalApproved = false;
                            showFinalRejected = false;
                            showFinalNA = true;
                            finalApproveText = 'NA'
                            break;
                    }
                } else {
                    finalProcessingStatusColor = '#808080'
                    showFinalPending = true;
                    showFinalApproved = false;
                    showFinalRejected = false;
                    showFinalNA = false;
                    finalApproveText = pendingStatus;
                }

                // My Leave Status Handling
                switch (String(getMyLeave.status)) {
                    case window.global.pending:
                        statusColor = '#808080'
                        break;
                    case window.global.approved:
                        statusColor = 'green'
                        break;
                    case window.global.rejected:
                        statusColor = 'red'
                        break;
                    case window.global.submitted:
                        statusColor = '#808080'
                        break;
                    case window.global.withdrawn:
                        statusColor = 'red'
                        break;
                    case window.global.cancelled:
                        statusColor = 'red'
                        break;
                }

                const type = isNewCompLeave ? 'guideline.' : (isCompLeave ? 'comp_leave.' : 'guideline.');

                setMyLeave({
                    type                : intl.formatMessage({ id: type + getMyLeave.type.name }),
                    startDate           : getMyLeave.start_date,
                    startTime           : isCompLeave ? getMyLeave.start_time : intl.formatMessage({ id: 'new_application.' + getMyLeave.start_time }),
                    untilDate           : getMyLeave.until_date,
                    endTime             : isCompLeave ? getMyLeave.end_time : intl.formatMessage({ id: 'new_application.' + getMyLeave.end_time }),
                    status              : intl.formatMessage({ id: 'status.' + String(getMyLeave.status) }),
                    firstApprover       : getFirstApprover,
                    firstApproverComment: getFirstProcessing.comment,
                    secApprover         : getSecApprover,
                    secApproverComment  : getSecProcessing.comment,
                    HRComment           : getFinalProcessing.comment,
                })

                if (page === 'My Leave' || page === 'Comp Leave Reqs') {
                    setShowModel(true);
                } else {
                    setShowModel(false);
                }

                setShowCompetent(true);
            })
    }, []);

    return (
        <MuiThemeProvider theme={muiTheme}>
            {showModel ?
                <Modal
                    aria-labelledby="view-details-title"
                    aria-describedby="view-details-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.modalPaper}>
                            {showCompetent ?
                                <React.Fragment>
                                    <div className={classes.typeDiv}>
                                        <Typography className={classes.title}>
                                            {myLeave.type}
                                        </Typography>
                                    </div>
                                    <StyledDivider />
                                    <Typography className={classes.subtitle}>
                                        {intl.formatMessage({ id: 'common.from' })}: {moment(myLeave.startDate).format(window.global.displayFormat)} {myLeave.startTime}
                                    </Typography>
                                    <Typography className={classes.subtitle}>
                                        {intl.formatMessage({ id: 'common.to' })}: {moment(myLeave.untilDate).format(window.global.displayFormat)} {myLeave.endTime}
                                    </Typography>
                                    {showWithdrawnTime &&
                                        <Typography className={classes.subtitle}>
                                            {intl.formatMessage({ id: 'myleave.withdrawn_on' })}: {updatedTime}
                                        </Typography>
                                    }
                                    {showCancelledTime &&
                                        <Typography className={classes.subtitle}>
                                            {intl.formatMessage({ id: 'myleave.cancelled_on' })}: {updatedTime}
                                        </Typography>
                                    }
                                    <div className={classes.statusDiv}>
                                        <Typography>
                                            {intl.formatMessage({ id: 'table.status' })}:
                                    </Typography>
                                        <Button className={classes.statusButton} style={{ backgroundColor: statusColor }}>
                                            {myLeave.status}
                                        </Button>
                                    </div>
                                    {showTimeline &&
                                        <Timeline
                                            myLeave={myLeave}

                                            firstProcessingStatusColor={firstProcessingStatusColor}
                                            secProcessingStatusColor={secProcessingStatusColor}
                                            finalProcessingStatusColor={finalProcessingStatusColor}

                                            showFirstPending={showFirstPending}
                                            showFirstApproved={showFirstApproved}
                                            showFirstRejected={showFirstRejected}
                                            showFirstNA={showFirstNA}

                                            showSecPending={showSecPending}
                                            showSecApproved={showSecApproved}
                                            showSecRejected={showSecRejected}
                                            showSecNA={showSecNA}

                                            showFinalPending={showFinalPending}
                                            showFinalApproved={showFinalApproved}
                                            showFinalRejected={showFinalRejected}
                                            showFinalNA={showFinalNA}
                                            showFinalSeparator={showFinalSeparator}

                                            firstApproveText={firstApproveText}
                                            secApproveText={secApproveText}
                                            finalApproveText={finalApproveText}
                                            showFirstApprover={showFirstApprover}
                                            showSecApprover={showSecApprover}
                                        />
                                    }
                                    {showTimeline &&
                                        <Comment
                                            firstApprover={myLeave.firstApprover}
                                            firstApproverComment={myLeave.firstApproverComment}
                                            secApprover={myLeave.secApprover}
                                            secApproverComment={myLeave.secApproverComment}
                                            HRComment={myLeave.HRComment}
                                        />
                                    }
                                </React.Fragment>
                                :
                                <div className={classes.circularProgress}>
                                    <CircularProgress />
                                </div>
                            }
                        </div>
                    </Fade>
                </Modal >
                :
                <React.Fragment>
                    {showTimeline ?
                        ([
                            <Title key="1">
                                {intl.formatMessage({ id: 'myleave.progress' })}
                            </Title>,
                            <StyledDivider key="2" />,
                            <Timeline key="3"
                                myLeave={myLeave}

                                firstProcessingStatusColor={firstProcessingStatusColor}
                                secProcessingStatusColor={secProcessingStatusColor}
                                finalProcessingStatusColor={finalProcessingStatusColor}

                                showFirstPending={showFirstPending}
                                showFirstApproved={showFirstApproved}
                                showFirstRejected={showFirstRejected}
                                showFirstNA={showFirstNA}

                                showSecPending={showSecPending}
                                showSecApproved={showSecApproved}
                                showSecRejected={showSecRejected}
                                showSecNA={showSecNA}

                                showFinalPending={showFinalPending}
                                showFinalApproved={showFinalApproved}
                                showFinalRejected={showFinalRejected}
                                showFinalNA={showFinalNA}
                                showFinalSeparator={showFinalSeparator}

                                firstApproveText={firstApproveText}
                                secApproveText={secApproveText}
                                finalApproveText={finalApproveText}
                                showFirstApprover={showFirstApprover}
                                showSecApprover={showSecApprover}
                            />,
                            <Comment key="4"
                                firstApprover={myLeave.firstApprover}
                                firstApproverComment={myLeave.firstApproverComment}
                                secApprover={myLeave.secApprover}
                                secApproverComment={myLeave.secApproverComment}
                                HRComment={myLeave.HRComment}
                            />
                        ])
                        :
                        <div className={classes.circularProgress}>
                            <CircularProgress />
                        </div>
                    }
                </React.Fragment>
            }
        </MuiThemeProvider>
    )
}